import React from 'react';
import { BrandButton, Highlight } from './ui';

/* Figma "Banner" (node 33816:595): 1600×612 green card with the wave overlay. */
const CtaBanner = ({ cta, onAuth, wide = false }) => (
  <section id="cta" className="hp-container my-[clamp(40px,5.3333vw,96px)]" data-testid="final-cta-section">
    <div className="relative overflow-hidden rounded-[clamp(20px,1.6667vw,30px)] bg-brand-deep px-5 py-[clamp(56px,7.9444vw,143px)] text-center text-white">
      <img
        src="/brand/cta-waves.svg"
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full select-none object-cover"
      />
      <div className="relative">
        <h2 className={`hp-display mx-auto ${wide ? 'max-w-[13.55em]' : 'max-w-[9.48em]'}`}>
          <Highlight text={cta.title} accent="text-white" />
        </h2>
        <p className="mt-[clamp(14px,1.1111vw,20px)] text-[clamp(16px,1.2222vw,22px)] font-medium leading-[clamp(24px,1.9444vw,35px)]">
          {cta.subtitle}
        </p>
        <div className="mt-[clamp(20px,1.7222vw,31px)] flex flex-col items-center justify-center gap-3 min-[420px]:flex-row min-[420px]:gap-5">
          <BrandButton to={cta.primary_link || 'register'} onAuth={onAuth} variant="white" className="w-full min-[420px]:w-auto" data-testid="final-cta-button">
            {cta.primary_label}
          </BrandButton>
          <BrandButton to={cta.secondary_link} onAuth={onAuth} variant="ghost-white" className="w-full min-[420px]:w-auto">
            {cta.secondary_label}
          </BrandButton>
        </div>
      </div>
    </div>
  </section>
);

export default CtaBanner;
